import { Lesson } from 'components/LessonCalendar/props';

export interface PostRequestPayload {
  lessonId: string;
}

export const LESSON_API = `v1/lessons`;
